import {
    Directive,
    ElementRef,
    EventEmitter,
    HostListener,
    Output,
} from '@angular/core';

@Directive({
    selector: '[appClickOutside]',
})
export class ClickOutsideDirective {
    @Output()
    appClickOutside: EventEmitter<void> = new EventEmitter();

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: PointerEvent): void {
        const nativeElement: any = this.elementRef.nativeElement;
        const clickedInside: boolean = nativeElement.contains(event.target);
        if (!clickedInside) {
            this.appClickOutside.emit();
        }
    }

    constructor(private readonly elementRef: ElementRef) {}
}
